import styled from "styled-components"
import myTheme from "../../../theme"

export const Container = styled.div`
  width: 100%;
  box-shadow: 0px 0px 10px 0px rgba(0,0,0,.5);
`

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  max-width: 1200px;
  padding: 30px;
  margin: 60px auto;

  h2 {
    margin-bottom: 0;
    font-size: 2em;
    text-align: center;
  }

  div {
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    width: 100%;
  }

  .gatsby-image-wrapper {
    width: 200px;
    height: 200px;

    img {
      object-fit: contain !important;
    }
  }

  @media (max-width: ${myTheme.responsive.container}) {
    padding: 30px;
    div {
      flex-direction: column;
      margin: 0 auto;
    }
  }
`
